import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  // skill qualification categories
  getListOfSkillQualificationCategories(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/skill-qualification-categories?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSkillQualificationCategory(payload) {
    return Repository.post(`${resource}/skill-qualification-categories`, payload)
  },
  geteSkillQualificationCategory(id) {
    return Repository.get(`${resource}/skill-qualification-categories/${id}`,)
  },
  updateSkillQualificationCategory(id, payload) {
    return Repository.put(`${resource}/skill-qualification-categories/${id}`, payload)
  },
  getSkillQualificationCategoriesDropdown(type) {
    return Repository.get(`${resource}/skill-qualification-categories?is_paginate=0&filter[type]=${type}`)
  },

  // staff skills
  getListOfStaffSkills(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/staff-skills?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createStaffSkills(payload) {
    return Repository.post(`${resource}/staff-skills`, payload)
  },
  geteStaffSkill(id) {
    return Repository.get(`${resource}/staff-skills/${id}`,)
  },
  updateStaffSkills(id, payload) {
    return Repository.put(`${resource}/staff-skills/${id}`, payload)
  },
  getListOfStaffSkillsDropdown(is_paginate = 0) {
    return Repository.get(`${resource}/staff-skills?is_paginate=${is_paginate}`)
  },

  //skill qualification
  getListOfSkillQualifications(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/skill-qualifications?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSkillQualifications(payload) {
    return Repository.post(`${resource}/skill-qualifications`, payload)
  },
  getSkillQualification(id) {
    return Repository.get(`${resource}/skill-qualifications/${id}`,)
  },
  updateSkillQualifications(id, payload) {
    return Repository.put(`${resource}/skill-qualifications/${id}`, payload)
  },
  getListOfSkillQualificationsDropdown(is_paginate = 0) {
    return Repository.get(`${resource}/skill-qualifications?is_paginate=${is_paginate}`)
  },

  //manage my qualifications
  getListOfMyQualifications(staff_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/staff/${staff_id}/qualifications?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createMyQualifications(staff_id, payload) {
    return Repository.post(`/admin/staff/${staff_id}/qualifications`, payload)
  },
  getMyQualification(id) {
    return Repository.get(`/admin/qualifications/${id}`,)
  },
  updateMyQualifications(id, payload) {
    return Repository.put(`/admin/qualifications/${id}`, payload)
  },
  deleteMyQualifications(id) {
    return Repository.delete(`/admin/qualifications/${id}`)
  },

  //manage my skills
  getListOfMySkills(staff_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/staff/${staff_id}/skills?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createMySkills(staff_id, payload) {
    return Repository.post(`/admin/staff/${staff_id}/skills`, payload)
  },
  getMySkill(id) {
    return Repository.get(`/admin/skills/${id}`,)
  },
  updateMySkills(id, payload) {
    return Repository.put(`/admin/skills/${id}`, payload)
  },
  deleteMySkills(id) {
    return Repository.delete(`/admin/skills/${id}`)
  },

  //manage staff skills and qualifications
  getListOfAllStaffSkills(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/staff-skills?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfAllStaffQualifications(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/staff-qualifications?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
};
